export default {
  getSearchHistory: (state) => {
    return state.searchHistory
  },
  getFilterHistory: (state) => {
    return state.programFilterHistory
  },
  cartCache: (state) => {
    return state.cartCache
  }
}
